import { Component, OnDestroy, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LocalisationForm } from './forms/localisation-form';
import { updateLocalisationData } from '../../../../../store/actions/application.actions';
import { StagesComponent } from '../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ParcelsCrudComponent } from '../components/parcels/parcels-crud/parcels-crud.component';
import {
  ExposedMapControlComponent
} from '../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { FieldsetParcelsLabelPipe } from '../../../../../pipes/fieldset-parcels-label.pipe';
import { RoadControlsSetComponent } from '../components/road-controls-set/road-controls-set.component';

export interface LocalisationDataComponentConfig {
  stages: string[];
  successUrl: string;
  cancelUrl: string;
}

@Component({
  selector: 'app-localisation-data-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    ParcelsCrudComponent,
    ExposedMapControlComponent,
    FieldsetParcelsLabelPipe,
    RoadControlsSetComponent
  ],
  providers: [LocalisationForm],
  templateUrl: './localisation-data-section.component.html'
})
export class LocalisationDataSectionComponent implements OnDestroy {

  public successUrl: string | undefined = this.route.snapshot.data['successUrl'];

  public cancelUrl: string | undefined = this.route.snapshot.data['cancelUrl'];

  public stages: string[] = this.route.snapshot.data['stages'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchApplication: Subscription = toObservable(this.application).subscribe((app) => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store,
    public form: LocalisationForm
  ) {
  }

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateLocalisationData({
        currentApp,
        payload: this.form.toWriteModel(),
        parcels: this.form.parcelsValues,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            [this.successUrl],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate([this.cancelUrl], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
